import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { CsvUploadType } from '../../../../types/csvUploadConfiguration';
import CsvUploadConfigurationsScreen from '../../../components/CsvUploadConfiguration/CsvUploadConfigurationsScreen';
import ReorderRulesOverviewPane from './Panes/ReorderRules/ReferenceDataSettingsReorderRulesPane';
import ReferenceDataExportPane from './Panes/ReferenceDataExportPane';
import CreateProductMasterDataExportConfigurationPane from './Panes/Export/Panes/CreateProductMasterDataExportConfigurationPane';
import UpdateProductMasterDataExportConfigurationPane from './Panes/Export/Panes/UpdateProductMasterDataExportConfigurationPane';
import HandlingUnitsOverviewPane from './Panes/HandlingUnits/HandlingUnitsOverviewPane';
import ProductMasterDataOverviewCrumb from '../../../components/Breadcrumbs/crumbs/ProductMasterDataOverviewCrumb';
import { Breadcrumbs } from '../../../components/Breadcrumbs';
import ProductMasterDataSettingsCrumb from '../../../components/Breadcrumbs/crumbs/ProductMasterDataSettingsCrumb';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { translate } from '../../../../types/translation/Translator';
import { Tab, Tabs } from '../../../components/Tabs';
import { Routing } from '../../../../util/routes.util';
import CsvUploadConfigurationUpdatePane from '../../../components/CsvUploadConfiguration/CsvUploadConfigurationUpdatePane';
import CreateReorderRuleScreen from '../../Common/ReorderRules/CreateReorderRuleScreen';
import UpdateReorderRuleScreen from '../../Common/ReorderRules/UpdateReorderRuleScreen';
import ReorderRuleSettingsScreen from './Panes/ReorderRules/Settings/ReorderRuleSettingsScreen';
import BinConstraintsOverviewPane from './Panes/BinConstraints/BinConstraintOverviewPane';
import ProductMasterDataTableSettingsPane from './Panes/TableSettings/ProductMasterDataTableSettingsPane';

export default function ProductMasterDataSettingsScreen() {
  const navigate = useNavigate();

  return (
    <Routes>
      <Route path='stock_triggers/create/*' element={<CreateReorderRuleScreen />} />
      <Route path='stock_triggers/update/:id/*' element={<UpdateReorderRuleScreen />} />
      <Route path='stock_triggers/settings/*' element={<ReorderRuleSettingsScreen />} />
      <Route
        path='*'
        element={
          <div className='flex h-full flex-col overflow-hidden'>
            <Breadcrumbs>
              <ProductMasterDataOverviewCrumb />
              <ProductMasterDataSettingsCrumb current />
            </Breadcrumbs>
            <div className='content-y-breadcrumbs flex flex-grow flex-col overflow-hidden'>
              <Tabs padding>
                <Tab
                  text={translate({ key: TranslationKey.importConfigurations })}
                  path={Routing.productMasterData.settings.importConfigurations.overview()}
                  key={'import_configurations'}
                />
                <Tab
                  text={translate({ key: TranslationKey.stockTriggers })}
                  path={Routing.productMasterData.settings.stockTriggers.overview()}
                  key={'stock_triggers'}
                />
                <Tab
                  text={translate({ key: TranslationKey.reporting })}
                  path={Routing.productMasterData.settings.report.overview()}
                  key={'report'}
                />
                <Tab
                  text={translate({ key: TranslationKey.handlingUnit, count: 'plural' })}
                  path={Routing.productMasterData.settings.handlingUnits.overview()}
                  key={'handling_units'}
                />
                <Tab
                  text={translate({ key: TranslationKey.tableSettings })}
                  path={Routing.productMasterData.settings.tableSettings.overview()}
                  key={'table_settings'}
                />
                <Tab
                  text={translate({ key: TranslationKey.binConstraint, count: 'plural' })}
                  path={Routing.productMasterData.settings.binConstraints.overview()}
                  key={'bin_constraints'}
                />
              </Tabs>

              <div className='flex-grow overflow-hidden'>
                <Routes>
                  <Route
                    path={'import_configurations/*'}
                    element={
                      <CsvUploadConfigurationsScreen
                        type={CsvUploadType.productMasterData}
                        backPath='/reference_data'
                      />
                    }
                  />
                  <Route
                    path={'import_configurations/update/:id/*'}
                    element={
                      <CsvUploadConfigurationUpdatePane
                        type={CsvUploadType.productMasterData}
                        onDone={() => navigate(Routing.productMasterData.settings.overview())}
                      />
                    }
                  />

                  <Route path='stock_triggers/*' element={<ReorderRulesOverviewPane />} />
                  <Route path='report/*' element={<ReferenceDataExportPane />} />
                  <Route path='handling_units/*' element={<HandlingUnitsOverviewPane />} />
                  <Route path='table_settings/*' element={<ProductMasterDataTableSettingsPane />} />
                  <Route path='bin_constraints/*' element={<BinConstraintsOverviewPane />} />

                  <Route path='report/create' element={<CreateProductMasterDataExportConfigurationPane />} />
                  <Route path='report/update/:id' element={<UpdateProductMasterDataExportConfigurationPane />} />
                </Routes>
              </div>
            </div>
          </div>
        }
      />
    </Routes>
  );
}
